import { Component, Injector, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NAVIGATION_TREE } from 'src/app/config/navigation-tree';
import { CanvasLayoutDataService } from '../../angular-common/canvas-layout-data.service';
import { RoutingDataService } from '../../angular-common/routing-data.service';
import { log } from '../../angular-common/util';
import { MenuNode} from '../base-types';

export interface Stylable{
  width?: string
  height?: string
  margin?: string
  border?: string
  borderColor?: string
  underlineColor?: string
  borderBottomColor?: string
  borderRadius?: string
  padding?: string
  bgColor?: string
  fontSize?: string
  fontWeight?: string
  fontColor?: string
  uppercase?: boolean
}

export interface MenuSettings extends Stylable {
  mode?: 'bordered'|'underlined',
  spacing?: string,
  menuItemStyle?: Stylable,
  hoverMenuItemStyle?: Stylable,
  selectedMenuItemStyle?: Stylable
}

@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent {

  @Input() set context(context: 'public'|'private') {
    this.options = NAVIGATION_TREE.filter(el=>context=='public' ? el.showInPublicMenu 
                                              : context=='private' ? el.showInPrivateMenu
                                              : false );
  }

  /**
   * true se il menu deve essere disegnato in modalità mobile, ossia con gli item in verticale
   */
  @Input() mobile: boolean = false;


  @Input() set settings(_settings: MenuSettings){
    this._initSettings(_settings)
  }
  get settings(){
    return this._settings;
  }
  _settings: any

  options: MenuNode[];
  
  hoverId: string|number;
  
  constructor(
    public routingDataService: RoutingDataService,
    public canvasLayoutDataService: CanvasLayoutDataService,
    protected _injector: Injector
  ) {
    this._initSettings();
  }

  public select(optionId: string|number){
    log('HorizontalMenuComponent', 'select()', 'optionId', optionId, 'lightGreen')
    const url = this.options.filter(el=>el.id==optionId)[0].url;
    const fragments = url.split('#');
    if(fragments.length==1)
      this._injector.get(Router).navigate([fragments[0]])
    else  
      this._injector.get(Router).navigate([fragments[0]], { fragment: fragments[1] })
    
    this.canvasLayoutDataService.closeSidenav1();
  }

  public hover(optionId: string|number){
    this.hoverId = optionId;
  }

  public unhover(){
    this.hoverId = null;
  }

  private _initSettings(settings?: MenuSettings){
    const _settings = JSON.parse(JSON.stringify(settings||{}))

    _settings.mode = _settings.mode || 'bordered';
    _settings.width = _settings.width || '100%';
    _settings.spacing = _settings.spacing || '4px';

    _settings.menuItemStyle = _settings.menuItemStyle || {}
    _settings.hoverMenuItemStyle = _settings.hoverMenuItemStyle || JSON.parse(JSON.stringify(_settings.menuItemStyle))
    _settings.selectedMenuItemStyle = _settings.selectedMenuItemStyle || JSON.parse(JSON.stringify(_settings.menuItemStyle))
    
    this._settings = _settings
  }
}
